import {
  Box,
  Button,
  InputLabel,
  makeStyles,
  OutlinedInput,
  Typography,
} from "@material-ui/core";
import React from "react";
import Modal from "react-awesome-modal";
import { Field, Form, Formik, ErrorMessage } from "formik";
import { editUserSchema } from "./modalForms";
import { backend } from "../../../../../api";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import { fetchCustomer } from "../../../../../redux-store/customer/customer";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const useStyles = makeStyles((theme) => ({
  modalContainer: {
    width: "90%",
    margin: "20px auto",
  },
  modalHeading: {
    fontSize: 24,
    fontWeight: 550,
    marginBottom: 0,
  },
  modalLine: {
    margin: "20px auto",
    width: "100%",
    color: theme.palette.secondary.dark,
  },
  fieldLabel: {
    color: theme.palette.secondary.light,
    marginBottom: "8px",
    fontSize: "15px",
    fontWeight: 500,
  },
  inputField: {
    padding: "10px",
    borderRadius: "2px",
  },
  submitBtn: {
    color: theme.palette.secondary.light,
    backgroundColor: theme.palette.primary.main,
    width: 100,
    borderRadius: 2,
    padding: "8px 0",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: "white",
    },
  },
  cancelBtn: {
    backgroundColor: theme.palette.secondary.dark,
    width: 100,
    borderRadius: 2,
    padding: "8px 0",
    color: theme.palette.secondary.light,
  },
}));

function EditUserModal(props) {
  const dispatch = useDispatch();
  const { visible, closeModal, name, phone, userId } = props;
  const classes = useStyles();

  const handleFormSubmit = (values) => {
    const editUser = {
      name: values.name,
      phone: values.contact,
    };
    backend
      .put(`/customer/${userId}`, editUser)
      .then((res) => {
        dispatch(fetchCustomer(res.data.data));
        closeModal();
        if (res.data.message === "Update Successful") {
          Swal.fire({
            title: "Congratulations",
            icon: "success",
            confirmButtonText: "OK",
            text: res.data.message,
          }).then((result) => {
            if (result.isConfirmed) {
            }
          });
        }
      })
      .catch((err) => {
        if (err.response) {
          toast.error(err.response.data.message);
        } else {
          toast.error(err.message);
        }
      });
  };
  return (
    <Modal
      visible={visible}
      width="500"
      effect="fadeInUp"
      onClickAway={closeModal}
    >
      <div className={classes.modalContainer}>
        <h3 className={classes.modalHeading}>Edit User Details</h3>
        <hr className={classes.modalLine} />
        <Formik
          initialValues={{
            name: name,
            contact: phone,
          }}
          onSubmit={(values) => handleFormSubmit(values)}
          validationSchema={editUserSchema}
        >
          {({ errors, values, setFieldValue }) => {
            return (
              <Form>
                <Box mb={2}>
                  <InputLabel className={classes.fieldLabel}>Name</InputLabel>
                  <Field
                    type="text"
                    name="name"
                    as={OutlinedInput}
                    fullWidth
                    error={errors.name}
                    className={classes.inputField}
                  />
                  <ErrorMessage name="name">
                    {(error) => (
                      <Typography variant="subtitle2" color="error">
                        {error}
                      </Typography>
                    )}
                  </ErrorMessage>
                </Box>
                <Box mb={2}>
                  <InputLabel className={classes.fieldLabel}>
                    Contact No.
                  </InputLabel>
                  {/* <Field type="text" name="contact" as={OutlinedInput} fullWidth error={errors.contact} className={classes.inputField} /> */}
                  <PhoneInput
                    value={values.contact}
                    type="text"
                    name="contact"
                    className={classes.inputField}
                    inputProps={{
                      name: "contact",
                      required: true,
                      autoFocus: true,
                    }}
                    onChange={(value, country, e, formattedValue) => {
                      // handleChange(value)
                      setFieldValue("contact", value);
                    }}
                    containerStyle={{
                      width: "100%",
                    }}
                    inputStyle={{
                      width: "100%",
                      padding: "20px 40px",
                    }}
                  />
                  <ErrorMessage name="contact">
                    {(error) => (
                      <Typography variant="subtitle2" color="error">
                        {error}
                      </Typography>
                    )}
                  </ErrorMessage>
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Button className={classes.cancelBtn} onClick={closeModal}>
                    Cancel
                  </Button>
                  <Button className={classes.submitBtn} type="submit">
                    Update
                  </Button>
                </Box>
              </Form>
            );
          }}
        </Formik>
      </div>
    </Modal>
  );
}

export default EditUserModal;
